/* import __COLOCATED_TEMPLATE__ from './option.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
export default Component.extend({
  tagName: '',
  value: null,
  selectedValue: null,
  onClick() {},
  isSelected: computed('value', 'selectedValue', function () {
    return this.value === this.selectedValue;
  })
});